<shared-status-icon [state]="calculateStep(1)" [iconName]="agentIcon" />
<shared-arrow-line [state]="calculateStep(2)" />
<shared-status-icon [state]="calculateStep(2)" [iconName]="pickupIcon" />
<shared-arrow-line [state]="calculateStep(3)" />
<shared-status-icon [state]="calculateStep(3)" [iconName]="carIcon" />
